// extracted by mini-css-extract-plugin
export default {"element":"CtaBox-module--element--85a7a","container":"CtaBox-module--container--805dd","link":"CtaBox-module--link--b5928"};